import { WizardDialogContextState } from "models/propTypes/wizardPropTypes";
import React, { createContext, PropsWithChildren } from "react";
import { ContextConstants } from "utils/constants";
import { WizardDialogReducer } from "./reducer";

const initialState: WizardDialogContextState = {
  currentStep: 0,
  numOfSteps: 0,
  next: () => {},
  previous: () => {},
  setCurrentStep: () => {},
  setNumOfSteps: () => {},
  setWizardFields: () => {},
  wizardFields: {},
  currentStepErrors: false,
  values: {},
  setCurrentStepErrors: () => {},
  setValues: () => {},
};

export const WizardDialogContext = createContext<WizardDialogContextState | undefined>(undefined);

const WizardDialogContextProvider: React.FC<PropsWithChildren> = (props) => {
  const [state, dispatch] = React.useReducer(WizardDialogReducer, initialState);

  const next = () => {
    dispatch({ type: ContextConstants.WizardActions.MOVE_NEXT });
  };

  const previous = () => {
    dispatch({ type: ContextConstants.WizardActions.MOVE_PREV });
  };

  const setCurrentStep = (currentStep: number) => {
    dispatch({ type: ContextConstants.WizardActions.SET_CURRENT_STEP, payload: currentStep });
  };

  const setNumOfSteps = (count: number) => {
    dispatch({ type: ContextConstants.WizardActions.SET_NUMBER_OF_STEPS, payload: count });
  };

  const setWizardFields = (data: any) => {
    dispatch({ type: ContextConstants.WizardActions.SET_WIZARD_FIELDS, payload: data });
  };

  const setCurrentStepErrors = (data: any) => {
    dispatch({ type: ContextConstants.WizardActions.SET_CURRENT_STEP_ERRORS, payload: data });
  };

  const setValues = (data: any) => {
    dispatch({ type: ContextConstants.WizardActions.SET_VALUES, payload: data });
  };

  return (
    <WizardDialogContext.Provider
      value={{
        ...state,
        next,
        previous,
        setCurrentStep,
        setNumOfSteps,
        setWizardFields,
        setCurrentStepErrors,
        setValues,
      }}
    >
      {props.children}
    </WizardDialogContext.Provider>
  );
};

export default WizardDialogContextProvider;
